import { validateRedirect } from "@baton/core";
import { inTeamsTab, signInEntry } from "../teams/tab.ts";

/**
 * Leave the authenticated entry for the sign-in screen, carrying the current path as
 * `redirect` only when it passes the FR-015-153 test (it always does for a path this
 * router produced, but the test runs rather than the assumption). Inside the Microsoft Teams
 * tab the sign-in screen is the tab itself (`teams/tab.ts`, 2026-10-02), which signs in through
 * Teams again and carries no `redirect`.
 */
export function leaveForSignIn(): void {
  if (inTeamsTab()) {
    window.location.replace(signInEntry());
    return;
  }
  const current = `${window.location.pathname}${window.location.search}`;
  const redirect = validateRedirect(current);
  const target = redirect === null || redirect === "/" ? signInEntry() : `${signInEntry()}?redirect=${encodeURIComponent(redirect)}`;
  window.location.replace(target);
}
